export const CONTACT_EXAMS_OPTIONS = [
  {
    key: 'antraquinona',
    label: 'Antraquinona',
  },
  {
    key: 'neomicina',
    label: 'Neomicina',
  },
  {
    key: 'amerchol-101',
    label: 'Amerchol 101',
  },
  {
    key: 'balsamo_do_peru',
    label: 'Bálsamo-do-peru',
  },
  {
    key: 'nitrofurazona',
    label: 'Nitrofurazona',
  },
  {
    key: 'bronopol',
    label: 'Bronopol',
  },
  {
    key: 'benzocaina',
    label: 'Benzocaína',
  },
  {
    key: 'paraben_mix',
    label: 'Paraben (MIX)',
  },
  {
    key: 'cloracetamida',
    label: 'Cloracetamida',
  },
  {
    key: 'bicromato_de_potassio',
    label: 'Bicromato de potássio',
  },
  {
    key: 'parafenilenodiamina',
    label: 'Parafenilenodiamina',
  },
  {
    key: 'clorexidina',
    label: 'Clorexidina',
  },
  {
    key: 'butil_fenol_para_terciário',
    label: 'Butil-fenol-para-terciário',
  },
  {
    key: 'perfume_mix',
    label: 'Perfume (MIX)',
  },
  {
    key: 'terebintina',
    label: 'Terebintina',
  },
  {
    key: 'carba_mix',
    label: 'Carba (MIX)',
  },
  {
    key: 'ppd_mix',
    label: 'PPD (MIX)',
  },
  {
    key: 'tioglicolato_de_amonio',
    label: 'Tioglicolato de Amônio',
  },
  {
    key: 'cloreto_de_cobalto',
    label: 'Cloreto de Cobalto',
  },
  {
    key: 'prometazina',
    label: 'Prometazina',
  },
  {
    key: 'trietanolamina',
    label: 'Trietanolamina',
  },
  {
    key: 'colofonio',
    label: 'Colofônio',
  },
  {
    key: 'quaternium_15',
    label: 'Quaternium 15',
  },
  {
    key: 'terebintina',
    label: 'Terebintina',
  },
  {
    key: 'etilenodiamina',
    label: 'Etilenodiamina',
  },
  {
    key: 'quinolina_mix',
    label: 'Quinolina (MIX)',
  },
  {
    key: 'thimerosal',
    label: 'Thimerosal',
  },
  {
    key: 'formaldeido',
    label: 'Formaldeído',
  },
  {
    key: 'resina_0_epoxi',
    label: 'Resina 0 epóxi',
  },
  {
    key: 'tiuram_mix',
    label: 'Tiuram (MIX)',
  },
  {
    key: 'hidroquinona',
    label: 'Hidroquinona',
  },
  {
    key: 'sulfato_de_niquel',
    label: 'Sulfato de níquel',
  },
  {
    key: 'acido_sorbico',
    label: 'Ácido sórbico',
  },
  {
    key: 'irgasan',
    label: 'Irgasan',
  },
  {
    key: 'mercapto_mix',
    label: 'Mercapto (MIX)',
  },
  {
    key: 'kathon_cg',
    label: 'Kathon CG',
  },
  {
    key: 'bht',
    label: 'BHT (Butil hidroxi tolueno)',
  },
  {
    key: 'lanolina',
    label: 'Lanolina',
  },
  {
    key: 'geraml_15',
    label: 'Germal 15 (Imidazolinil ureia)',
  },
  {
    key: 'resina',
    label: 'Resina (Tonsilamida/formaldeido)',
  },
]
